import { Box, Typography } from '@mui/material';
import { AlarmConditionItem } from 'src/features/alarms/components/alarm-condition-item';

import { TriggerInfo } from 'src/types/alarms';
import { formatSecondsToDhms, formatUTCDateToLocal } from 'src/utilities';

import {
  StyledConditionItem,
  titleStyle,
  conditionsBox,
  StyledConditionItemColumn,
} from '../style';
import { LiveDataAlarmConditionRowItem } from '../liveDataAlarmConditionRowItem/LiveDataAlarmConditionRowItem';

type Props = {
  triggerInfo: TriggerInfo;
  testId: string;
};

export const LiveDataAlarmTriggerInfo = ({ triggerInfo, testId }: Props) => (
  <Box sx={{ marginTop: '8px' }}>
    <StyledConditionItem>
      <StyledConditionItemColumn>
        <Typography data-sm="Trigger Conditions" sx={titleStyle}>
          Trigger Conditions
        </Typography>
        <Box sx={conditionsBox} data-sm={testId}>
          {triggerInfo.triggerConditions.map((condition, i: number) => {
            const isExtendedRow = i > 0;
            return (
              <AlarmConditionItem
                key={condition.inputId}
                isExtendedRow={isExtendedRow}
                condition={condition}
              />
            );
          })}
        </Box>
      </StyledConditionItemColumn>
      <StyledConditionItemColumn>
        <LiveDataAlarmConditionRowItem
          description="Trigger Delay"
          value={formatSecondsToDhms(triggerInfo.triggerDelay)}
          testId="trigger-delay"
        />
        <LiveDataAlarmConditionRowItem
          description="Triggered At"
          value={formatUTCDateToLocal(false, triggerInfo.triggeredAt)}
          testId="triggered-at"
        />
      </StyledConditionItemColumn>
    </StyledConditionItem>
  </Box>
);
